import api from './api';

export function isTwoFactorChallenge(data) {
    if (!data || typeof data !== 'object') return false;
    if (data.twoFactorRequired === true) return true;
    return Boolean(data.challengeToken) && !data.acessToken;
}

export default {
    isTwoFactorChallenge,
    async token(userData) {
        try {
          const headers = {
            'Content-Type': 'application/json', 
        };
          const response = await api.post('/auth/login', userData);
          return response
        } catch (error) {
          console.error('Erro ao solicitar token');
          throw error;
        }
       
      },
      async verifyTwoFactor(payload) {
        try {
          const response = await api.post('/auth/login/2fa', {
            challengeToken: payload.challengeToken,
            code: payload.code,
          });
          return response;
        } catch (error) {
          console.error('Erro ao verificar o código de duas etapas');
          throw error;
        }
      },
      async resendTwoFactor(challengeToken) {
        try {
          const response = await api.post('/auth/login/2fa/resend', {
            challengeToken,
          });
          return response;
        } catch (error) {
          console.error('Erro ao reenviar o código de duas etapas');
          throw error;
        }
      },
      async requestEmailLink(payload) {
        try {
          const response = await api.post('/auth/login/email-link', {
            email: payload.email,
            recaptchaToken: payload.recaptchaToken,
            redirectUrl: payload.redirectUrl,
          });
          return response;
        } catch (error) {
          console.error('Erro ao solicitar link de acesso por e-mail');
          throw error;
        }
      },
      async chooseTwoFactorMethod(payload) {
        try {
          const response = await api.post('/auth/login/2fa/method', {
            challengeToken: payload.challengeToken,
            method: payload.method,
          });
          return response;
        } catch (error) {
          console.error('Erro ao escolher o método de duas etapas');
          throw error;
        }
      },
      async validateEmailLink(token, domain) {
        try {
          const response = await api.post('/auth/login/email-link/validate', {
            token,
            domain: domain || undefined,
          });
          return response;
        } catch (error) {
          console.error('Erro ao validar o link de acesso por e-mail');
          throw error;
        }
      },
      async redirectCompany(accessToken, domain) {
        try {
          const response = await api.post('/auth/redirect', { domain }, {
            headers: { Authorization: `Bearer ${accessToken}` },
          });
          return response;
        } catch (error) {
          console.error('Erro ao trocar de empresa:', error);
          throw error;
        }
      },
      async domain(accessToken, payload) {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
                'Content-Type': 'application/json', 
            };
            const response = await api.post('/auth/domain', payload ,{
                headers,
            });
            return response.data;
        } catch (error) {
            console.error('Erro ao acesso token:', error);
                // throw error;
        }
    },
    async logo(payload) {
      try {
          const headers = {
              'Content-Type': 'application/json', 
          };
          const response = await api.post('/ecommerce/logo', payload ,{
              headers,
          });
          return response.data;
      } catch (error) {
          console.error('Erro ao gerar logo:', error);
              throw error;
      }
  },
}